export * from './format';

/**
 * @desc
 * @param
 */
export function isNaN(obj: any) {
    return Object.prototype.toString.call(obj) === '[object Number]' && obj !== obj;
}

/**
 * @desc
 * @param
 */
export function parseNum(value: any) {
    value = parseFloat(value);
    if (isNaN(value)) {
        return 0;
    }
    return value;
}

/**
 * 人数展示，超出千后，以k表示，比如1.1k， 20k
 * @param num {int} 要格式化的数字
 */
 export function peopleNotation(num: number) {
    if (num > 99999) {
        return (num / 1000).toFixed() + 'k';
    } else if (num > 999) {
        return (num / 1000).toFixed(1) + 'k';
    }
    return num;
}
